/* eslint-disable eqeqeq */
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { State } from 'vuex-class'

import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import RecordTypesHandler from '@/mixins/record-types'
import ListPage from '@/mixins/list-page'
@Component({
  components: {
    AppBreadcrumbs
  }
})
export default class QuotesList extends mixins(RecordTypesHandler, ListPage) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Insurance Cases'
    },
    {
      text: 'Create Cases2'
    }
  ];
  checked = false
  showga = false
  searchVal = '';
  ifRelatedList = false;
  showdirectinput = true;
  tableData = [];
  showBill = false
  showBill2 = false
  showBill3 = false
  showBill4 = false

  orderBy: {
    [key: string]: string;
  } = {
    name: 'NAME',
    status: 'STATUS',
    id: 'ID'
  };

  activeIndex: number = 0;
  currentIndex:number = 7;
  showcreate = true;
  showheaderinput = false;
  showheaderinput2 = false;
  showclomn = false;
  showclomn2 = false
  showinquiryinput = true
  drawer = false;
  tableLoading = false;
  form = {
    name: '',
    region: ''
  };
  percentage = 0
  visible2 = false;
  showselect = false;

  cancleshowcloumn2 () {
    this.showclomn2 = false
    this.showclomn = true
  }

  cancleshowcloumn () {
    this.showclomn = false
    this.showclomn2 = false
  }

  skipTo () {
    this.activeIndex++
    this.showclomn = false
  }

  showdirectinputs () {
    this.showdirectinput = false
    this.activeIndex++
  }

  showselectFn () {
    this.showheaderinput = !this.showheaderinput
    this.visible2 = false
  }
  showheaderinput2Fn () {
    this.showheaderinput = false
    this.showheaderinput2 = true
  }
  visibleFn () {
    this.visible2 = !this.visible2
    this.showheaderinput = false
  }
  hideheaderinput2Fn () {
    this.showheaderinput2 = false
    this.showheaderinput = false
  }
}
